/* eslint-disable complexity */
import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import { Parallax } from 'react-scroll-parallax'

const bem = new BEMHelper('demo-wrapper')

export default function DemoWrapper({ children, dark, light, description, aspect, spaceless, center, parallax }) {
  const [w, h] = (aspect || '').split('/')

  return (
    <div {...bem('', { dark, light, spaceless, parallax, center })}>
      {parallax ? (
        <Parallax y={[5, -25]} tagOuter="figure">
          <div {...bem('wrapper')}>
            <svg
              viewBox={aspect && w && h ? `0 0 ${w} ${h}` : '0 0 3 2'}
              role="presentation"
              {...bem('aspect')}
            />

            <div {...bem('content')}>
                {children}
            </div>
          </div>
        </Parallax>
      ) : (
        <>
          <div {...bem('wrapper')}>
            <svg
              viewBox={aspect && w && h ? `0 0 ${w} ${h}` : '0 0 3 2'}
              role="presentation"
              {...bem('aspect')}
            />

            <div {...bem('content')}>
                {children}
            </div>
          </div>
          {description && <p {...bem('description')}>{description}</p>}
        </>
      )}
    </div>
  )
}

DemoWrapper.propTypes = {
  children: T.any.isRequired,
  aspect: T.string,
  description: T.string,
  spaceless: T.bool,
  center: T.bool,
  dark: T.bool,
  light: T.bool,
  parallax: T.bool,
}
